import type {
  BulkUploadAction,
  BulkUploadFileStatus,
  BulkUploadState,
} from "@/types/bulk-upload";

export const createInitialBulkUploadState = (): BulkUploadState => ({
  files: [],
  isProcessing: false,
  isPaused: false,
  currentFileId: null,
  batchId: crypto.randomUUID(),
});

export const bulkUploadReducer = (
  state: BulkUploadState,
  action: BulkUploadAction,
): BulkUploadState => {
  switch (action.type) {
    case "ADD_FILES":
      return { ...state, files: [...state.files, ...action.payload] };

    case "REMOVE_FILE":
      return { ...state, files: state.files.filter((file) => file.id !== action.payload) };

    case "UPDATE_FILE": {
      const { id, updates } = action.payload;
      return {
        ...state,
        files: state.files.map((file) => (file.id === id ? { ...file, ...updates } : file)),
        currentFileId: updates.status === "uploading" ? id : state.currentFileId,
      };
    }

    case "SET_PROCESSING":
      return { ...state, isProcessing: action.payload };

    case "SET_PAUSED":
      return { ...state, isPaused: action.payload };

    case "SET_AGENT":
      return {
        ...state,
        agentId: action.payload.id,
        agentName: action.payload.name,
      };

    case "CLEAR_QUEUE":
      return createInitialBulkUploadState();

    case "CLEAR_COMPLETED":
      return { ...state, files: state.files.filter((file) => file.status !== "completed") };

    case "RETRY_FAILED":
      return {
        ...state,
        files: state.files.map((file) =>
          file.status === "failed"
            ? {
                ...file,
                status: "pending" as BulkUploadFileStatus,
                error: undefined,
                progress: 0,
              }
            : file,
        ),
      };

    case "RESET":
      return createInitialBulkUploadState();

    default:
      return state;
  }
};
